import React, { useContext, useReducer } from "react";
import axios from "axios";
import AdContext from "./AdContext";
import AdReducer from "./AdReducer";
import {
  CLOUDINARY_BROWSE_LOADING,
  CLOUDINARY_VIDEO_URL,
  CLOUDINARY_VIDEO_ERROR,
  CLOUDINARY_VIDEOS,
  CLOUDINARY_IMAGE_URL,
  CLOUDINARY_IMAGES,
  // CLOUDINARY_PUBLIC_ID,
  FACEBOOK_AD_FORM_DETAILS,
  FACEBOOK_AD_FORM_ERROR,
  FACEBOOK_AD_ID,
  FACEBOOK_AD_ERROR,
} from "../../types";

// Contexts
import LayoutContext from "../../layout/LayoutContext";
import DashboardContext from "../../facebook_profiles/dashboard/DashboardContext";

const AdState = (props) => {
  const default_form = {
    name: "",
    page_id: "",
    CTA: "",
    link: "",
    image: "",
    image_state: {
      fileInputState: "",
      previewSource: "",
      selectedFile: "",
    },
  };

  const default_error = {
    name: "",
    page_id: "",
    CTA: "",
    link: "",
    image: "",
  };

  const initialState = {
    browse_loading: false,
    video_url: null,
    video_error: null,
    videos: null,
    video_next_cursor: null,
    images: null,
    image_next_cursor: null,
    // video_public_id_found: false,

    list_delivery: [
      "ALL",
      "ACTIVE",
      "PAUSED",
      "DELETED",
      "PENDING_REVIEW",
      "DISAPPROVED",
      "PREAPPROVED",
      "PENDING_BILLING_INFO",
      "CAMPAIGN_PAUSED",
      "ARCHIVED",
      "ADSET_PAUSED",
      "IN_PROCESS",
      "WITH_ISSUES",
    ],
    list_cta: ["LEARN_MORE"],
    form_details: [],
    form_errors: [],
    ad_id: [],
    ad_error: null,
  };

  const [state, dispatch] = useReducer(AdReducer, initialState);
  const { setLoading, setAlert } = useContext(LayoutContext);
  // const { setDisplayContent } = useContext(DashboardContext);

  const setVideoUrl = (url) => {
    dispatch({
      type: CLOUDINARY_VIDEO_URL,
      payload: url ? url : null,
    });
  };

  const setVideoError = (error) => {
    dispatch({
      type: CLOUDINARY_VIDEO_ERROR,
      payload: error ? error : null,
    });
  };

  const uploadVideo = async (base64EncodedVideo, videoFileName) => {
    setLoading(true);

    try {
      const res = await axios.post("/api/facebook_ad/video/upload", {
        data: JSON.stringify(base64EncodedVideo),
        name: videoFileName,
      });

      if (res.data) {
        dispatch({
          type: CLOUDINARY_VIDEO_URL,
          payload: res.data,
        });
        dispatch({
          type: CLOUDINARY_VIDEO_ERROR,
          payload: null,
        });
        setAlert("Video uploaded successful.", "success");
      }
    } catch (err) {
      console.log(err.response.data);
      setAlert("Video upload failed", "error");
    }

    setLoading(false);
  };

  const browseVideo = async (more) => {
    try {
      let res;

      if (more) {
        dispatch({
          type: CLOUDINARY_BROWSE_LOADING,
          payload: true,
        });

        res = await axios.get(
          `/api/facebook_ad/video/browse?next_cursor=${state.video_next_cursor}`
        );
      } else {
        res = await axios.get("/api/facebook_ad/video/browse");
      }

      dispatch({
        type: CLOUDINARY_VIDEOS,
        payload: res.data,
      });
    } catch (err) {
      console.log(err.response.data);
      setAlert("Video browse failed", "error");
    }

    dispatch({
      type: CLOUDINARY_BROWSE_LOADING,
      payload: false,
    });
  };

  const setImageUrl = (url, ad_id) => {
    url = url ? url : null;
    dispatch({
      type: CLOUDINARY_IMAGE_URL,
      payload: [url, ad_id],
    });
  };

  const uploadImage = async (base64EncodedImage, imageFileName, ad_id) => {
    setLoading(true);

    try {
      const res = await axios.post("/api/facebook_ad/image/upload", {
        data: JSON.stringify(base64EncodedImage),
        name: imageFileName,
      });

      if (res.data) {
        dispatch({
          type: CLOUDINARY_IMAGE_URL,
          payload: [res.data, ad_id],
        });

        state.form_errors[ad_id] = { ...state.form_errors[ad_id], image: "" };
        dispatch({
          type: FACEBOOK_AD_FORM_ERROR,
          payload: state.form_errors,
        });

        setAlert("Image uploaded successful.", "success");
      }
    } catch (err) {
      console.log(err.response.data);
      setAlert("Image upload failed", "error");
    }

    setLoading(false);
  };

  const browseImage = async (more) => {
    try {
      let res;

      if (more) {
        dispatch({
          type: CLOUDINARY_BROWSE_LOADING,
          payload: true,
        });

        res = await axios.get(
          `/api/facebook_ad/image/browse?next_cursor=${state.image_next_cursor}`
        );
      } else {
        res = await axios.get("/api/facebook_ad/image/browse");
      }

      dispatch({
        type: CLOUDINARY_IMAGES,
        payload: res.data,
      });
    } catch (err) {
      console.log(err.response.data);
      setAlert("Image browse failed", "error");
    }

    dispatch({
      type: CLOUDINARY_BROWSE_LOADING,
      payload: false,
    });
  };

  // const searchVideo = async (public_id) => {
  //   setLoading(true);

  //   try {
  //     const res = await axios.get(
  //       `/api/facebook_ad/video/search?public_id=${public_id}`
  //     );

  //     dispatch({
  //       type: CLOUDINARY_PUBLIC_ID,
  //       payload: res.data === 0 ? false : true,
  //     });
  //   } catch (err) {
  //     console.log(err.response.data);
  //     setAlert("Video search failed", "error");
  //   }

  //   setLoading(false);
  // };

  const setFormDetails = (details) => {
    dispatch({
      type: FACEBOOK_AD_FORM_DETAILS,
      payload: details,
    });
  };

  const setFormErrors = (errors) => {
    dispatch({
      type: FACEBOOK_AD_FORM_ERROR,
      payload: errors,
    });
  };

  const resetForm = () => {
    dispatch({
      type: FACEBOOK_AD_FORM_DETAILS,
      payload: [],
    });
    dispatch({
      type: FACEBOOK_AD_FORM_ERROR,
      payload: [],
    });
  };

  const createAd = async (profile_id, ad_account, adset_id) => {
    setLoading(true);

    let details = [];

    state.form_details.map((ad) => {
      details.push({
        name: ad.name,
        page_id: ad.page_id,
        CTA: ad.CTA,
        link: ad.page_id,
        image: ad.image,
      });
    });

    console.log(profile_id, ad_account, adset_id);
    console.log(state.video_url);
    console.log(details);

    setLoading(false);
  };

  return (
    <AdContext.Provider
      value={{
        browse_loading: state.browse_loading,
        video_url: state.video_url,
        video_error: state.video_error,
        videos: state.videos,
        video_next_cursor: state.video_next_cursor,
        images: state.images,
        image_next_cursor: state.image_next_cursor,
        // video_public_id_found: state.video_public_id_found,
        setVideoUrl,
        setVideoError,
        uploadVideo,
        browseVideo,
        setImageUrl,
        uploadImage,
        browseImage,
        // searchVideo,

        default_form,
        default_error,
        list_delivery: state.list_delivery,
        list_cta: state.list_cta,
        form_details: state.form_details,
        form_errors: state.form_errors,
        ad_id: state.ad_id,
        ad_error: state.ad_error,
        setFormDetails,
        setFormErrors,
        resetForm,
        createAd,
      }}
    >
      {props.children}{" "}
    </AdContext.Provider>
  );
};

export default AdState;
